import { getUserInfo } from 'application/adapters/auth/getUserInfo';

export type PortalPrivilege =
	| 'fresh_add_tickets'
	| 'fresh_view_tickets'
	| 'fresh_close_tickets'
	| 'engnyte_access'
	| 'is_colab_customer'
	| 'lab_access';

// UI gates - a user gets an area when they hold any of its privileges.
// Only the derived booleans (Models.Access) ever reach the client; the privileges themselves stay server-side.
const ACCESS_RULES: Record<keyof Models.Access, PortalPrivilege[]> = {
	// "Support" service nav item
	support: ['fresh_add_tickets', 'fresh_view_tickets', 'fresh_close_tickets', 'is_colab_customer'],
	// "Struers SmartLab" service nav item
	smartLab: ['engnyte_access', 'is_colab_customer', 'lab_access'],
	// "Service History" tab in the Support Center - is_colab_customer users always have a Business Partner relation
	serviceHistory: ['is_colab_customer'],
};

export const NO_ACCESS: Models.Access = {
	support: false,
	smartLab: false,
	serviceHistory: false,
};

export const toPrivileges = (raw: PortalPrivilege | PortalPrivilege[] | null | undefined): PortalPrivilege[] => [].concat(raw ?? []);

export const getAccess = (privileges: PortalPrivilege[]): Models.Access =>
	Object.fromEntries(
		Object.entries(ACCESS_RULES).map(([area, required]) => [area, privileges.some((privilege) => required.includes(privilege))]),
	) as unknown as Models.Access;

type DxpGroup = 'TestGruppe' | 'is_colab_customer' | 'engnyte_access' | 'fresh_add_tickets' | 'fresh_close_tickets' | 'fresh_view_tickets';

export interface UserData {
	sub: string;
	email: string;
	name: string;
	aud: string;
	contact_role: string;
	contact_id: string;
	portal_privilege?: PortalPrivilege | PortalPrivilege[];
	portal_vkpid: string;
	dxp_group: DxpGroup[];
	dxp_catalog: string;
	oi_prst: string;
	oi_au_id: string;
	client_id: string;
	oi_tkn_id: string;
	scope: string;
	exp: number;
	iss: string;
	iat: number;
}

export async function getUserData(accessToken: string): Promise<UserData | null> {
	if (!accessToken) return null;
	return await getUserInfo(accessToken);
}
